import { render, staticRenderFns } from "./DashboardDownloads.vue?vue&type=template&id=8f00bc5a&scoped=true"
import script from "./DashboardDownloads.vue?vue&type=script&lang=js"
export * from "./DashboardDownloads.vue?vue&type=script&lang=js"
import style0 from "./DashboardDownloads.vue?vue&type=style&index=0&id=8f00bc5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f00bc5a",
  null
  
)

export default component.exports